import { Partial } from "@pdfking/tfunc"

import type { CacheBackend } from "#public"
import type { SingleValueCacheType } from "#public"

/**
 * Views one key of a cache as a standalone value: get/set/delete already bound
 * to `key`, so callers never repeat it.
 */
export const SingleValueCache = <V>(
  cache: CacheBackend<V>,
  key = "Main"
): SingleValueCacheType<V> => ({
  delete: Partial(cache.delete, key),
  get: Partial(cache.get, key),
  set: Partial(cache.set, key),
})
